import { Label, Select } from '@blimo/ui';
import { useId } from 'react';

/** Toolbar row above lists. @param {{ children: import('react').ReactNode }} props */
export function FilterBar({ children }) {
  return <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-end">{children}</div>;
}

/**
 * Labelled native select for list filters. Empty value = "alle".
 * @param {{ label: string, value?: string, onChange: (value: string|undefined) => void, options: Array<{ value: string, label: string }>, allLabel?: string }} props
 */
export function FilterSelect({ label, value, onChange, options, allLabel = 'Alle' }) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor={id} className="text-xs text-muted-foreground">
        {label}
      </Label>
      <Select id={id} size="sm" value={value ?? ''} onChange={(e) => onChange(e.target.value || undefined)} wrapperClassName="sm:w-44">
        <option value="">{allLabel}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </div>
  );
}
